import { OrganizationConfig } from 'services/organization/type';

type GetDefaultClosingMessageParams = {
  organizationConfig?: OrganizationConfig | null;
  savedClosingMessage?: string | null;
  userEmail?: string;
};

export const getDefaultClosingMessage = ({
  organizationConfig,
  savedClosingMessage,
  userEmail
}: GetDefaultClosingMessageParams): string => {
  // Get saved campaign message, use if available
  if (savedClosingMessage) {
    return savedClosingMessage;
  }

  // Get organizationConfig message, use if available
  if (organizationConfig?.closingMessage) {
    return organizationConfig.closingMessage;
  }

  // Otherwise use default message
  if (userEmail) {
    return `No problem. Thanks for letting me know. If you have any questions, email ${userEmail}.`;
  }

  return '';
};
